import axios from "axios";
import { FetchWithAuth } from "./apiService";
const LIMIT = process.env.REACT_APP_LIMIT_PAGINATION || 20;

export async function getInvoicesBySeller(auth, id, page = 0, limit = LIMIT) {
	return FetchWithAuth(auth, "invoices/seller/" + id + "?page=" + page + "&limit=" + limit);
}

export async function getInvoicesByTag(auth, id, page = 0, limit = LIMIT) {
	return FetchWithAuth(auth, "invoices/tag/" + id + "?page=" + page + "&limit=" + limit);
}

export async function deleteInvoice(auth, id) {
	return FetchWithAuth(auth, "invoices/" + id, null, { method: "DELETE" });
}

export async function updateInvoice(auth, id, date, descr, importo, tags_id) {
	return FetchWithAuth(
		auth,
		"invoices/" + id,
		{ date, descr, importo, tags_id },
		{ method: "PUT" }
	);
}

export async function searchInvoices(
	auth,
	descr = "",
	start_date = "",
	end_date = "",
	page = 1,
	limit = LIMIT,
	excludedTagIds = []
) {
	return FetchWithAuth(
		auth,
		`invoices/search?descr=${descr}&start_date=${start_date}&end_date=${end_date}&limit=${limit}&page=${page}&excluded_tags=${excludedTagIds.join(
			","
		)}`
	);
}

export async function createInvoice(auth, sellerId, invoice) {
	const apiUrl = process.env.REACT_APP_API_URL;

	const formData = new FormData();

	formData.append("date", invoice.date);
	formData.append("descr", invoice.descr);
	formData.append("importo", invoice.importo);
	formData.append("sellerId", sellerId);

	const tagsCsv = invoice.tags ? invoice.tags.map((tag) => tag.id).join(",") : "";
	formData.append("tags", tagsCsv);

	if (invoice.file) formData.append("pdf", invoice.file);

	try {
		const response = await axios.post(apiUrl + "invoices", formData, {
			headers: {
				"Content-Type": "multipart/form-data",
				Authorization: `Bearer ${auth.token}`,
			},
		});

		return response.status === 201;
	} catch (error) {
		console.error("Errore nella richiesta:", error);
		return false;
	}
}
